import React, { useEffect, useState } from "react";
import SectionTable2 from "./SectionTable2";
import Modal from "../../../elements/Modal";
import EligibilityQuizContent from "../../../modalcontent/EligibilityQuizContent";
import UpcomingApplications from "../../../modalcontent/UpcomingApplications";
import dayjs from "dayjs";
import { scholarshipList } from "../../../../services/scholarshipService";
import useFetch from "../../../../hooks/useFetch";
import ApplicationDetailsModal from "./modals/ApplicationDetailsModal";
import { useBanner } from "../../../../providers/BannerProviders";
import Image from "../../../elements/Image";
import ApplicationModalFront from "./modals/ApplicationModalFront";
import ApplicationNotOpenInfoModal from "./modals/ApplicationNotOpenInfoModal";
import { checkDateStatus, removeDuplicateFromArray } from "../../../../helpers";

const Timeline = () => {
  const [isApply, setApply] = useState({ isOpen: false, data: null });
  const [notOpenQuizModal, setNotOpenQuizModal] = useState({
    isOpen: false,
    data: null,
  });
  const [detailsModal, setDetailsModal] = useState({
    isOpen: false,
    data: null,
  });
  const [applicationModal, setApplicationModal] = useState({
    isOpen: false,
    data: null,
  });
  const { data: timeLineData } = useBanner();
  const applyBanner = timeLineData?.data?.find(
    (item) => item?.bannerType === "apply"
  );
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
  });
  const [allScholarships, setAllScholarships] = useState({ tableData: [] });

  const getApplyButtonProps = (item) => {
    const {
      isQualified,
      publishEndDate,
      isStartedApplying,
      publishDate,
      statusDetails,
    } = item;

    const isPast = checkDateStatus(publishEndDate) === "past";
    const isUpcoming = checkDateStatus(publishDate) === "upcoming";

    if (isUpcoming) {
      return {
        label: "Opening Soon",
        onClick: () => setNotOpenQuizModal({ data: item, isOpen: true }),
      };
    }

    if (isQualified) {
      if (isPast && isStartedApplying === "notStarted") {
        return { label: "Currently Unavailable" };
      }
      if (statusDetails?.title === "Draft") {
        return {
          label: "Incomplete/Draft",
          onClick: () => setApply({ isOpen: true, data: item }),
        };
      }

      switch (isStartedApplying) {
        case "completed":
          return { label: "Applied" };
        case "ongoing":
          return {
            label: "Incomplete/Draft",
            onClick: () => setApply({ isOpen: true, data: item }),
          };
        case "notStarted":
          return {
            label: "Apply",
            onClick: () => setApply({ isOpen: true, data: item }),
          };
        default:
          return { label: "Currently Unavailable" };
      }
    } else {
      if (isStartedApplying === "completed") {
        return { label: "Applied" };
      }

      return {
        label: isStartedApplying === "ongoing" ? "Incomplete/Draft" : "Apply",
        onClick: () => setApply({ isOpen: true, data: item }),
      };
    }
  };

  const { data, isLoading: timelineLoading } = useFetch({
    dependencies: ["font-scholarship-timeline-2", filters],
    fetchFunction: async () => {
      const res = await scholarshipList({
        status: 1,
        ...filters,
        scholarship: "front",
      });
      return {
        tableData: [
          {
            _id: 1,
            title: "Available Opportunities",
            subdata: res?.docs?.data?.map((item) => ({
              ...item,
              startDate: item?.publishDate
                ? dayjs(item?.publishDate).format("MMMM DD, YYYY")
                : "-",
              endDate: item?.publishEndDate
                ? dayjs(item?.publishEndDate).format("MMMM DD, YYYY")
                : "Ongoing",
              viewAction: {
                label:
                  getApplyButtonProps(item).label === "Apply"
                    ? checkDateStatus(item?.publishEndDate) === "past"
                      ? "Not Available"
                      : "View Details"
                    : "View Soon",
                isLink: false,
                onClick:
                  getApplyButtonProps(item).label === "Apply"
                    ? () => {
                        if (checkDateStatus(item?.publishEndDate) === "past") {
                          return;
                        } else {
                          setDetailsModal({ isOpen: true, data: item });
                        }
                      }
                    : null,
              },
            })),
          },
        ],
        metaData: res?.docs?.metadata,
      };
    },
  });

  useEffect(() => {
    if (data?.tableData?.length) {
      setAllScholarships((prev) => {
        const previousSubdata = prev.tableData?.[0]?.subdata || [];
        const newSubdata = data.tableData?.[0]?.subdata || [];

        const mergedSubdata = removeDuplicateFromArray([
          ...previousSubdata,
          ...newSubdata,
        ]);

        return {
          ...data,
          tableData: [
            {
              ...data.tableData[0],
              subdata: mergedSubdata,
            },
          ],
        };
      });
    }
  }, [data]);

  return (
    <>
      {/* this is comment */}
      <div className="space-y-10">
        <div className="relative text-center space-y-6 max-w-6xl mx-auto">
          {applyBanner?.details?.timeline?.description && (
            <div
              className="text-base xls:text-lg xls:font-medium font-Gotham"
              dangerouslySetInnerHTML={{
                __html: applyBanner?.details?.timeline?.description,
              }}
            ></div>
          )}
        </div>
        {allScholarships?.tableData?.length > 0 && (
          <div className="">
            {allScholarships?.tableData?.map((item, index) => (
              <SectionTable2
                key={index}
                data={item}
                timelineLoading={timelineLoading}
                scholarshipData={data}
                setFilters={setFilters}
              />
            ))}
          </div>
        )}
        {applyBanner?.details?.timeline?.image?.url && (
          <div className="w-[350px] rounded-full overflow-hidden mx-auto relative text-center mt-4">
            <Image
              src={applyBanner?.details?.timeline?.image?.url}
              effect={"fade"}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
      <Modal
        isOpen={isApply?.isOpen}
        setIsOpen={() => setApply({ isOpen: false, data: null })}
        title={"Eligibility Quiz"}
        size="lg"
      >
        <EligibilityQuizContent
          data={isApply?.data}
          okHandler={() => setApply({ isOpen: false, data: null })}
        />
      </Modal>

      <ApplicationNotOpenInfoModal
        isOpen={notOpenQuizModal?.isOpen}
        close={() => {
          setNotOpenQuizModal({ isOpen: false, data: null });
        }}
        data={notOpenQuizModal?.data}
      />
      <ApplicationDetailsModal
        open={detailsModal?.isOpen}
        data={detailsModal?.data}
        close={() => setDetailsModal({ isOpen: false, data: null })}
        onApply={(data) => {
          setApply({ isOpen: true, data: data });
          setDetailsModal({ isOpen: false, data: null });
        }}
      />
      {applicationModal.isOpen && (
        <ApplicationModalFront
          open={applicationModal?.isOpen}
          close={() => {
            setApplicationModal({ isOpen: false, data: null });
          }}
          details={applicationModal.data}
        />
      )}
    </>
  );
};

export default Timeline;
